<template>
  <div id="processinfos">
    <el-tabs
      v-show="!dialog"
      class="content"
      v-model="activeTab"
      type="card"
      @tab-remove="removeTab"
    >
      <el-tab-pane class="have-page" label="流程列表" name="0">
        <div class="button-group">
          <div class="filling"></div>
          <el-select
            size="small"
            v-model="filter"
            placeholder="流程所属组"
            @change="packSearch"
            style="flex: 0 0 90px;"
          >
            <el-option label="未调度" value="noscheduled"> </el-option>
            <el-option label="已调度" value="scheduled"> </el-option>
            <el-option label="全部" value=""> </el-option>
          </el-select>
          <el-select
            size="small"
            v-model="appfilter"
            placeholder="流程所属应用"
            @change="packSearch"
            clearable
            filterable
            remote
            :remote-method="getAppData"
          >
            <el-option
              v-for="app in appOptions"
              :key="app.appId"
              :label="app.name"
              :value="app.appId"
            >
            </el-option>
          </el-select>

          <el-input
            size="small"
            placeholder="名字或描述包含"
            v-model="serachName"
            class="filter-input"
            @keyup.enter.native="packSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="packSearch"
            ></el-button>
          </el-input>

          <el-button
            class="first-button"
            type="primary"
            size="small"
            @click="newProcess"
          >
            新建流程
          </el-button>

          <el-button size="small" @click="importTask">
            导入流程
          </el-button>
        </div>
        <el-table
          v-loading="loading"
          :data="tableData"
          height="calc(100% - 32px - 32px - var(--padding))"
        >
          <el-table-column prop="name" label="流程名称" min-width="210">
            <template slot-scope="scope">
              <div class="path" @click="newTabs(scope.row)">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="creator"
            label="所有者"
            width=""
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="scheduleCron"
            label="调度策略"
            width=""
            min-width="160"
          >
          </el-table-column>

          <el-table-column
            prop="appName"
            label="应用名"
            width=""
            min-width="200"
          >
          </el-table-column>
          <el-table-column prop="" label="状态" width="" min-width="90">
            <template slot-scope="scope">
              <span>{{ scope.row.scheduled ? "已" : "未" }}调度</span>
            </template>
          </el-table-column>
          <el-table-column prop="nextTime" label="下次执行时间" min-width="200">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="200">
          </el-table-column>
          <el-table-column prop="modifyTime" label="修改时间" min-width="200">
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述"
            width=""
            min-width="500"
          >
          </el-table-column>
        </el-table>
        <page-trun
          :fixed="true"
          :disabled="loading"
          :page="page"
          :path="`${filter}_${nameContains}_`"
          :queryData="queryData"
          @pageTrun="pageTrun"
        />
      </el-tab-pane>
      <el-tab-pane
        closable
        v-for="item in editableTabs"
        :key="item.title"
        :label="item.title"
        :name="item.title"
      >
        <process-info
          :taskId="item.taskId"
          @refush="refush"
          @addTab="newTabs"
          @close="removeTab(item.title)"
        />
      </el-tab-pane>
    </el-tabs>
    <process
      v-if="dialog"
      @buildQuit="dialog = false"
      :routerOwnerId="routerOwnerId"
    />
    <import-task :dialog.sync="importDialog" :ownerId="routerOwnerId" />
  </div>
</template>

<script>
import process from "@/components/process/index.vue";
import processInfo from "./processinfo.vue";
import eltab from "@/mixin/eltab.js";
import ImportTask from "./importTask.vue";

export default {
  name: "processinfos",
  data() {
    return {
      loading: false,
      dialog: false,
      importDialog: false,
      activeTab: "0",
      editableTabs: [],
      page: {
        pageIndex: 1,
        hasMore: false,
        limit: 20
      },
      queryData: {},
      serachName: "",
      nameContains: "",
      appId: "",
      filter: "scheduled",
      appfilter: "",
      queryUrl: "",
      routerOwnerId: "",
      appOptions: []
    };
  },
  computed: {
    tableData() {
      let data = this.queryData[
        `${this.filter}_${this.nameContains}_${this.page.pageIndex}`
      ];
      if (data) {
        return data.data;
      }
      return [];
    },
    jobSearchName() {
      return this.$store.state.jobSearchName;
    }
  },
  mounted() {
    this.getAppData();
    let appRow = this.$route.query;
    if (appRow.appId && appRow.appId !== this.appId) {
      this.appfilter = appRow.appId;
      this.filter = "";
      this.serachName = "";
      this.routerOwnerId = appRow.ownerId;
      this.packSearch();
    } else if (appRow.flowName) {
      this.filter = "";
      this.serachName = appRow.flowName;
      this.packSearch();
    } else if (this.jobSearchName) {
      // 执行实例跳转 显示job
      this.newTabs(this.jobSearchName);
      this.$store.dispatch("setSerachName", "");
    } else if (!Object.keys(this.queryData).length) {
      this.getData();
    } else if (!appRow.appId && this.appId) {
      this.serachName = this.jobSearchName;
      this.appfilter = "";
      this.appId = "";
      this.filter = "";
      this.packSearch();
    }
  },
  mixins: [eltab],
  methods: {
    getData() {
      this.loading = true;
      this.queryUrl = `/gavial/v1/task/view/tasks?pageIndex=${
        this.page.pageIndex
      }&pageSize=${this.page.limit}&scheduled=${this.filter}&keyWord=${
        this.nameContains
      }${this.appId ? `&appId=${this.appId}` : ""}`;
      this.query();
    },
    getAppData(query = this.$route.query.name || "") {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$http
          .get(`/gavial/v1/app/list?pageIndex=1&keyWord=${query}`)
          .then(res => {
            this.appOptions = res.data.data;
          });
      });
    },
    query() {
      this.$http
        .get(this.queryUrl)
        .then(res => {
          this.$set(
            this.queryData,
            `${this.filter}_${this.nameContains}_${res.data.pageIndex}`,
            res.data
          );
          this.page.pageIndex = res.data.pageIndex;
          this.page.hasMore = res.data.hasMore;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newTabs(row) {
      let tab = this.editableTabs.find(tab => tab.title === row.name);
      if (tab) {
        this.activeTab = tab.title;
      } else {
        this.editableTabs.push({
          title: row.name,
          taskId: row.taskId
        });
        this.activeTab = row.name;
      }
    },
    newProcess() {
      this.dialog = true;
    },
    importTask() {
      this.importDialog = true;
    },
    pageTrun(v) {
      this.page.pageIndex = v;
      if (
        !this.queryData[
          `${this.filter}_${this.nameContains}_${this.page.pageIndex}`
        ]
      ) {
        this.getData();
      }
    },
    packSearch() {
      this.nameContains = this.serachName;
      this.appId = this.appfilter;
      this.page.pageIndex = 1;
      this.getData();
    },
    refush() {
      this.loading = false;
      this.query();
    }
  },
  components: {
    process,
    processInfo,
    ImportTask
  }
};
</script>

<style lang="scss" scoped>
#processinfos {
  height: 100%;
  position: relative;
  .content {
    height: 100%;
  }
  .button-group {
    & > .el-select,
    & > .el-input,
    & > .el-button {
      margin-left: 10px;
    }
    & > .el-select {
      width: 140px;
    }
    & > .el-input {
      width: 240px;
    }
  }
}
</style>
